// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../phoenix-app/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".questionContainer--3CZ2c{background:#fff;padding:24px;box-shadow:0 2px 8px rgba(0,0,0,.1);width:100%;height:auto;box-sizing:border-box}.questionText--3ulRL{font-size:1.2rem;margin-bottom:20px;color:#333;text-align:center}.optionsList--284r_{display:flex;flex-direction:column;gap:12px}.optionItem--1hS5-{display:flex;align-items:center;padding:12px 16px;background:#f7f9fc;border-radius:8px}.radioInput--1gu9k{width:18px;height:18px;margin-right:16px !important;margin-top:0 !important;pointer-events:none;accent-color:#000}.optionLabel--1HhqP{font-size:1rem;margin-bottom:0;color:#333;line-height:1}", ""]);
// Exports
exports.locals = {
	"questionContainer": "questionContainer--3CZ2c",
	"questionText": "questionText--3ulRL",
	"optionsList": "optionsList--284r_",
	"optionItem": "optionItem--1hS5-",
	"radioInput": "radioInput--1gu9k",
	"optionLabel": "optionLabel--1HhqP"
};
module.exports = exports;
